import { useContext } from "react";

import { MultiFormPromptsContext } from "./MultiFormPromptsContext.ts";

export const useMultiFormPromptsContext = () => {
  return useContext(MultiFormPromptsContext);
};
